import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const coda = defineConnector({
  identifier: "coda",
  name: "Coda",
  tagLine: "Collaborative workspace",
  logo,
  protocol: "http",
  tags: ["productivity", "documents"],
  defaultUrlPattern: () => "https://coda\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Coda API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Coda Account Settings](https://coda.io/account) and scroll down to **API Settings** to generate an API token.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API Token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://coda.io/apis/v1/whoami",
  },
});
